export default __webpack_public_path__ + "static/media/1.9e995d43.png";